/**
 * Native lazy-loader helper
 *
 * Adds class image--ready when image is loaded
 */

const lazyload = () => {

  const observeContainer = document.getElementById('page');
  if (!observeContainer) {
    return;
  }

  const setImageLoaded = (image) => {
    if (image.classList) {
      image.classList.remove('image--loading');
      image.classList.add('image--ready');
    }
  };

  const initOnContainer = (container) => {
    if (!container) {
      return;
    }
    const images = container.querySelectorAll('.image--loading, .wp-image');
    if (images.length) {
      for (let i = 0; i < images.length; i++) {
        let image = images[i];
        if (image.tagName == 'IMG') {
          if (image.complete) {
            setImageLoaded(image);
          } else {
            image.addEventListener('load', (e) => {
              setImageLoaded(e.target);
            }, {once : true});
          }
        }
      }
    }
  };

  // observe and hook new images
  const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) {
        for (let addedNode of mutation.addedNodes) {
          if (addedNode.querySelectorAll) {
            initOnContainer(addedNode);
          }
        }
      }
    }
  });

  // observe for new images
  observer.observe(observeContainer, {
    attributes: false,
    childList: true,
    subtree: true
  });

  // run on init
  initOnContainer(document);

};

lazyload();
